export default __webpack_public_path__ + "static/media/instagram.fa2a0fc9.svg";